/* ROOTLAND — Origen · contador con semilla */
(function () {
  'use strict';

  var pad = function (n) { return n < 10 ? '0' + n : String(n); };

  function init(root) {
    if (root.__roReady) return;
    root.__roReady = true;

    var launch = Date.parse(root.dataset.launch);
    var start = Date.parse(root.dataset.start);
    if (isNaN(launch)) return;
    if (isNaN(start) || start >= launch) start = launch - 10 * 864e5;

    // Permite probar estados: ?origen=0.5 en la URL, o los controles del editor
    var params = new URLSearchParams(window.location.search);
    var testGrowth = parseFloat(params.get('origen'));
    var override = parseFloat(root.dataset.growthOverride);
    if (!isNaN(testGrowth)) override = testGrowth;
    var forceBorn = root.dataset.forceBorn === 'true' || params.get('origen') === 'born';

    var timer = root.querySelector('[data-ro-timer]');
    var el = {
      d: root.querySelector('[data-ro="d"]'),
      h: root.querySelector('[data-ro="h"]'),
      m: root.querySelector('[data-ro="m"]'),
      s: root.querySelector('[data-ro="s"]')
    };
    var lastMinute = -1;
    var interval;

    function set(node, value) {
      if (node && node.textContent !== value) node.textContent = value;
    }

    function born() {
      root.classList.add('is-born');
      root.style.setProperty('--ro-growth', '1');
      if (interval) { clearInterval(interval); interval = null; }
    }

    function tick() {
      var now = Date.now();
      var left = Math.max(0, launch - now);

      var growth = !isNaN(override)
        ? Math.min(1, Math.max(0, override))
        : Math.min(1, Math.max(0, (now - start) / (launch - start)));
      root.style.setProperty('--ro-growth', growth.toFixed(4));

      if (left === 0 || forceBorn) { born(); return; }

      var total = Math.floor(left / 1000);
      var d = Math.floor(total / 86400);
      var h = Math.floor((total % 86400) / 3600);
      var m = Math.floor((total % 3600) / 60);
      var s = total % 60;

      set(el.d, pad(d));
      set(el.h, pad(h));
      set(el.m, pad(m));
      set(el.s, pad(s));

      // Texto para lectores de pantalla, una vez por minuto
      if (timer && m !== lastMinute) {
        lastMinute = m;
        timer.setAttribute('aria-label', 'Faltan ' + d + ' días, ' + h + ' horas y ' + m + ' minutos');
      }
    }

    // Controles para previsualizar sin esperar (usados por la página de vista previa)
    root.__ro = {
      setGrowth: function (v) { override = v; root.classList.remove('is-born'); forceBorn = false; tick(); if (!interval) interval = setInterval(tick, 1000); },
      bloom: function () { forceBorn = true; born(); },
      live: function () { override = NaN; forceBorn = false; root.classList.remove('is-born'); tick(); if (!interval) interval = setInterval(tick, 1000); }
    };

    // Arranca desde la semilla cerrada y deja que crezca hasta el estado real
    root.style.setProperty('--ro-growth', '0');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        root.classList.add('is-ready');
        tick();
        interval = setInterval(tick, 1000);
      });
    });

    // Al volver a la pestaña, sincroniza de inmediato
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) tick();
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('.ro').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  // Editor de temas de Shopify
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();